module.exports = __webpack_public_path__ + "/b9f90284664cc4683a694ce5c5e2591a.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/assets/branding_icon.svg
 ** module id = 1107
 ** module chunks = 0
 **/